document.querySelectorAll('.leadership-grid .leader').forEach(leader => {
	leader.addEventListener('click', () => {
		leader.classList.toggle('flipped');
	});
});
